module.exports = __webpack_public_path__ + "img/my-niubi-logo.b05c4d26.png";